import { render, staticRenderFns } from "./MinicartUpsells.vue?vue&type=template&id=543d7164&"
import script from "./MinicartUpsells.vue?vue&type=script&lang=js&"
export * from "./MinicartUpsells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports